import { floatLength } from "../../helper/number";
import { defaultValue } from "../../helper/utils";
import Vue from "vue";

function renderQuantity(el, value)
{
    const normalizedValue = defaultValue(value, 0);
    const decimals        = floatLength(normalizedValue);

    el.innerHTML = normalizedValue.toFixed(decimals).replace(".", App.decimalSeparator);
}

Vue.directive("basket-item-quantity",
    {
        bind(el, binding)
        {
            renderQuantity(el, binding.value);
        },

        update(el, binding)
        {
            renderQuantity(el, binding.value);
        }
    });
